import { FormControlLabel, Checkbox } from "@mui/material";
import React, { useState } from "react";

const initialValue = (state:any) => state.mailNonAssignable || false;

export default function NonAssignableComponent({ state, setState, isPropertyListChange }: any) {
	const [isAssignable, updateNonAssignable] = useState(initialValue(state));

	const toggleNonAssignable = (event: React.ChangeEvent<HTMLInputElement>) => {
		updateNonAssignable(event.target.checked);
		setState({
			...state,
			mailNonAssignable: event.target.checked,
		});
	};

	const isPropertyAlreadyAssigned = state.status === "Assigned" || state.status === "Processing";

	return (
		<>
			<FormControlLabel
				disabled={isPropertyAlreadyAssigned || isPropertyListChange}
				sx={{ ml: 2 }}
				control={<Checkbox checked={isAssignable} onChange={toggleNonAssignable} />}
				label="Non-Assignable"
			/>
		</>
	);
}
